/** Noon in Boston/New York on September 23 (EDT, not fixed-offset EST). */
export const DEFAULT_LAUNCH_AT = '2026-09-23T12:00:00-04:00';

export const getLaunchAt = () => {
  const configured = process.env.REACT_APP_LAUNCH_AT;
  return configured && Number.isFinite(Date.parse(configured)) ? configured : DEFAULT_LAUNCH_AT;
};

export const normalizeLaunchPath = (pathname: string) => pathname.replace(/\/+$/, '').toLowerCase() || '/';

// Host restriction is intentional: production builds on stage must remain usable.
// Setting the build-time flag to false disables the gate for a rollback build.
export const isLaunchGateHost = (hostname: string) =>
  process.env.REACT_APP_LAUNCH_GATE_ENABLED !== 'false'
  && ['allroomie.com', 'www.allroomie.com'].includes(hostname.toLowerCase());

export const isLaunchExemptPath = (pathname: string) => {
  const path = normalizeLaunchPath(pathname);
  return [
    '/about-us/henry-zhao', '/about-us/calvin-luo',
    '/agent/hooli-henryzhao', '/agent/hooli-cluo',
    '/sms-consent',
  ].includes(path)
    // Preserve existing B-side authentication and scheduling on both branches.
    || ['/business', '/bside', '/management'].some(prefix => path === prefix || path.startsWith(`${prefix}/`));
};
